var blocVideo = document.querySelectorAll('.pictures .bloc__wrapper--video');
var blocVideoIframe = document.querySelectorAll('.pictures .bloc__wrapper--iframe');
var closePopupArea = document.querySelectorAll('.pictures .popup-area .close-area-popup');

blocVideo.forEach(video => {
    video.addEventListener('click', function() {
        let popups = video.closest('.bloc').querySelectorAll('.popup-area');
        popups.forEach(popup => popup.classList.add('show-popup'));
    });
});

blocVideoIframe.forEach((iframeWrapper, index) => {
    iframeWrapper.addEventListener('click', function () {
        let videoIframes = iframeWrapper.closest('.bloc').querySelectorAll('.popup-area iframe');
        videoIframes.forEach(iframe => {
            if (!iframe.getAttribute('src')) {
                iframe.setAttribute('src', iframe.getAttribute('data-src'));
            }
        });
    });
});

closePopupArea.forEach(closeBtn => {
    closeBtn.addEventListener('click', function() {
        
        let popup = closeBtn.closest('.popup-area');
        let bloc = closeBtn.closest('.bloc');
        
        if (popup.classList.contains('show-popup')) {
            
            setTimeout(() => {
                popup.classList.remove('show-popup');
            }, 100);
           
        }

        let videoIframes = bloc.querySelectorAll('.popup-area iframe');
        videoIframes.forEach(iframe => iframe.removeAttribute('src'));
    });
});

// const observer = new MutationObserver(mutations => {
//     mutations.forEach(mutation => {
//         console.log(`Classe modifiée:`, mutation);
//     });
// });

// document.querySelectorAll('.popup-area').forEach(popup => {
//     observer.observe(popup, { attributes: true, attributeFilter: ['class'] });
// });

